/**
 * WhatsApp OAuth event types returned from Facebook's Embedded Signup flow.
 *
 * - FINISH: Standard OAuth completion (Cloud API only mode)
 * - FINISH_COEXISTENCE: OAuth completed with WhatsApp Business App coexistence enabled
 * - FINISH_ONLY_WABA: OAuth completed with only WABA sharing (phone number selection skipped)
 */
export const WHATSAPP_OAUTH_EVENTS = {
  FINISH: 'FINISH',
  FINISH_COEXISTENCE: 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING',
  FINISH_ONLY_WABA: 'FINISH_ONLY_WABA',
} as const;

export type WhatsAppOAuthEvent = (typeof WHATSAPP_OAUTH_EVENTS)[keyof typeof WHATSAPP_OAUTH_EVENTS];

/** Check if an OAuth event indicates coexistence mode was authorized. */
export const isCoexistenceEvent = (event: string): boolean =>
  event === WHATSAPP_OAUTH_EVENTS.FINISH_COEXISTENCE;

/**
 * Conflict codes returned by the WhatsApp preflight check on /callback and /reauthorise
 * when the requested phone_number_id is already attached to another integration
 * (WABA reuse across integrations is allowed — many numbers can share one WABA).
 *
 * - WITH_ACCESS: caller belongs to the owning account; UI gets owner details for a link.
 * - NO_ACCESS: owner is in an account the caller can't see; UI shows contact-support copy.
 */
export const WHATSAPP_CONFLICT_CODES = {
  WITH_ACCESS: 'whatsapp_already_attached_with_access',
  NO_ACCESS: 'whatsapp_already_attached_no_access',
} as const;

export type WhatsappConflictCode =
  (typeof WHATSAPP_CONFLICT_CODES)[keyof typeof WHATSAPP_CONFLICT_CODES];
